import { Box } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { pluralize } from "utils/stringUtils"
import { useShallow } from "zustand/shallow"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import { type OrderLine } from "@/graphql/codegen/graphql"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { convertUoMQuantity } from "@/utils/conversion"
import { formatNumber } from "@/utils/number"

export const OrderQuantityColumnReadOnly = ({ row }: { row: Row<OrderLine> }): ReactElement => {
  const { quantityInUom, uomId, numberOfPallets, product } = row.original

  const uoms = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const uom = uoms.find((uom) => uom.id === uomId)

  const convertedUoMValue = convertUoMQuantity(quantityInUom, uomId, product, "package")
  const convertedUom = uoms.find((uom) => uom.id === convertedUoMValue.uomId)
  const palletLabel = pluralize(numberOfPallets ?? 0, "Pallet", "Pallets")

  return (
    <Box className='flex gap-2'>
      <Box>{numberOfPallets}</Box>
      <Box>{palletLabel}</Box>
      <Box>
        {formatNumber(quantityInUom, UOM_RENDER_PRECISION)} {uom?.name} (
        {formatNumber(convertedUoMValue.amount, UOM_RENDER_PRECISION)} {convertedUom?.name})
      </Box>
    </Box>
  )
}
